module.exports = __webpack_public_path__ + "img/env_icon5.a6b3efd3.png";